import React from 'react';
import { Divider, Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import PlacementsPersonIcon from 'app/assets/images/WorkDesk/placement.svg';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectExpiringCounts, selectPipelineCounts } from '../Store/PlacementStatus.selector';
import { MediaQuery } from 'app/layout/MediaQuery';
import AlertIcon from 'app/assets/images/WorkDesk/alerts.svg';

const useStyles = makeStyles()({
  root: {
    flexGrow: 1,
  },
  icon: {
    display: 'flex',
    justifyContent: 'center',
  },
  textContent: {
    textAlign: 'center',
    whiteSpace: 'nowrap',
    fontWeight: 450,
    lineHeight: '32px',
  },
  title: {
    fontSize: 14,
    color: '#666666',
  },
  count: {
    color: '#555555',
    fontSize: 36,
  },
  container: {
    flexWrap: 'nowrap',
    width: '100%',
  },
  divider: {
    margin: '0 12px',
  },
});

export const PlacementTotalSection = () => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const { placementsCount } = useSelector(selectPipelineCounts);
  const expiringCount = useSelector(selectExpiringCounts);

  return (
    <>
      <div className={classes.root}>
        <Grid container xs={12} direction="row" classes={{ container: classes.container }}>
          <Grid item direction="column" classes={{ root: classes.container }}>
            <Grid item classes={{ root: classes.icon }}>
              <img src={PlacementsPersonIcon} alt="Placement person" />
            </Grid>
            <Grid item classes={{ root: `${classes.title} ${classes.textContent}` }}>
              {t('home.credentialingWorkDesk.placements')}
            </Grid>
            <Grid item classes={{ root: `${classes.count} ${classes.textContent}` }} aria-label="aggregate-count">
              {placementsCount}
            </Grid>
          </Grid>
          <MediaQuery minWidth={'xs'}>
            <Divider orientation="vertical" flexItem classes={{ root: classes.divider }} />
          </MediaQuery>
          <Grid item direction="column" classes={{ root: classes.container }}>
            <Grid item classes={{ root: classes.icon }}>
              <img src={AlertIcon} alt="Alert" />
            </Grid>
            <Grid item classes={{ root: `${classes.title} ${classes.textContent}` }}>
              {t('home.credentialingWorkDesk.expiring')}
            </Grid>
            <Grid item classes={{ root: `${classes.count} ${classes.textContent}` }} aria-label="aggregate-count">
              {expiringCount}
            </Grid>
          </Grid>
        </Grid>
      </div>
    </>
  );
};
